
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { NextSeo } from "@components/seo";
import { PVC } from "@consts/ppvc";
import type { IProduct } from "@type/products";
import { getAllPvcByParent } from "@utils/get-products";
import type { GetStaticProps, NextPage } from "next/types";
import useTranslation from "next-translate/useTranslation";
import { Breadcrumb } from "../../../components/breadcrumb";
interface IProductPage {
    products: IProduct[];
}
const WindowsPage: NextPage<IProductPage> = ({ products }) => {
    const { t } = useTranslation("pvc");
    return (<>
      <NextSeo languageAlternates={[
            { href: "https://knsokna.pl/pvc/windows", hrefLang: "x-default" },
            { href: "https://knswindows.com/pvc/windows", hrefLang: "en" },
            { href: "https://knsokna.pl/pvc/windows", hrefLang: "pl" },
            { href: "https://knsfenster.de/pvc/windows", hrefLang: "de" },
            { href: "https://kns-okna.eu/pvc/windows", hrefLang: "cs" },
            { href: "https://knsfinestre.it/pvc/windows", hrefLang: "it" },
            { href: "https://knsfenetres.fr/pvc/windows", hrefLang: "fr" },
            { href: "https://knsokna.eu/pvc/windows", hrefLang: "hu" },
        ]} title={t("windows.title")}/>
      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
          <Breadcrumb />
          <Products products={products}/>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const { products } = await getAllPvcByParent(PVC.WINDOWS[LOCALE as keyof typeof PVC.WINDOWS] as number, LOCALE);
    const slugOrder = ["veka", "gealan", "decco", "aluplast"];
    const sortedProducts = products.sort((a: {
        slug: string;
    }, b: {
        slug: string;
    }) => slugOrder.indexOf(a.slug) - slugOrder.indexOf(b.slug));
    // console.log(sortedProducts);
    return {
        props: {
            products: sortedProducts,
        },
    };
};
export default WindowsPage;

    async function __Next_Translate__getStaticProps__1a19cd2bfb5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/pvc/windows/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bfb5__ as getStaticProps }
  